import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {CloSecondaryNavigation, CloSecondaryNavigationTab, CloSecondaryNavigationTabContent, CloSecondaryNavigationTabTitle}
from './secondary-navigation';
import {SharedModule} from '../util/shared.module';

export {
  CloSecondaryNavigation, CloSecondaryNavigationTab, CloSecondaryNavigationTabContent, CloSecondaryNavigationTabTitle,
  CloSecondaryNavigationTabChangeEvent
} from './secondary-navigation';


const DIRECTIVES = [CloSecondaryNavigation, CloSecondaryNavigationTab, CloSecondaryNavigationTabContent,
  CloSecondaryNavigationTabTitle];

@NgModule({declarations: DIRECTIVES, exports: DIRECTIVES, imports: [CommonModule, SharedModule]})
export class CloSecondaryNavigationModule {
}
